import { API_HOST, PY_API_HOST } from "../lib/config"
import { Get, getWithUrl, postWithUrl } from "../lib/request"

 /**
 * @description method to call analytics data for table, get api
 * @author jagannath
 * @date 12/04/2021
 */
export const getTotalAnalyticsApi = () => {
    return getWithUrl(`${PY_API_HOST}/analytics`)
    // return Get('/analytics')
}

 /**
 * @description method to call graph data get api, for chart
 * @author jagannath
 * @date 13/04/2021
 * @param eventType: String - click | pageView | hover | videoPlay | download
 * @param filterBy: String - day | week | month | year
 */
export const getGraphDataApi = ({eventType, filterBy, startDate, endDate}, payload) =>{
    if( eventType === "users"){
        return  getWithUrl(`${PY_API_HOST}/bouncerate?startDate=${startDate}&endDate=${endDate}&filterBy=${filterById[filterBy]}`)
    }
    if( eventType === "sessiontime"){
        return  getWithUrl(`${PY_API_HOST}/sessiontime?startDate=${startDate}&endDate=${endDate}&filterBy=${filterById[filterBy]}`)
    }
    if( eventType === "trafficrate"){
        if(filterById[filterBy] == 5){
            return postWithUrl(`${PY_API_HOST}/trafficrate?filterBy=${filterById[filterBy]}`, {dates: payload})
        }
        return  postWithUrl(`${PY_API_HOST}/trafficrate?startDate=${startDate}&endDate=${endDate}&filterBy=${filterById[filterBy]}`)
    }
    return Get(`/graph/${eventType}?startDate=${startDate}&endDate=${endDate}&filterBy=${filterById[filterBy]}`)
}

 /**
 * @description method to call analytic table data get api, for chart
 * @author jagannath
 * @date 13/04/2021
 * @param eventType: String - click | pageView | hover | videoPlay | download
 * @param limit: Number - 10
 * @param skip: Number - 0
 */
  export const getAnalyticDataApi = ({eventType, skip=0,limit=10, startDate, endDate}) =>{

    return Get(`/analytics/${eventType}?skip=${skip}&limit=${limit}${startDate ? '&startDate='+startDate:''}${endDate ? '&endDate='+endDate:''}`)
}

export const downloadTableDataApi = async({eventType, startDate, endDate, pageName}) => {
    // console.log('eventType, startDate, endDate, pageName', eventType, startDate, endDate, pageName)
    let url = `/excel/${eventType}`;
    if(startDate){
        url = url + '?startDate=' + startDate;
        if(endDate){
            url = url+ '&endDate=' + endDate;
        }
    }
    if(endDate && !startDate){
        url = url + '?endDate=' + endDate;
    }
    if(pageName){
        if(startDate || endDate){
            url = url + '&pageName='+pageName
        }else{
            url = url + '?pageName='+pageName
        }
    }
    window.location = API_HOST + url;
 
    return Get(url, {responseType: 'blob'})
}

export const getHeatmapDataApi = ({eventType, filterBy, startDate, endDate}) => {
    let url = `${PY_API_HOST}/heatmap?startDate=${startDate}&endDate=${endDate}`
    return getWithUrl(url)
}

export const exportHeatmapDataApi = async({startDate, endDate}) => {
    const url = `${PY_API_HOST}/export/heatmap?startDate=${startDate}&endDate=${endDate}`;
    window.location = url;
    return getWithUrl(url)
}


const filterById = {
    "day": 1,
    "week": 2,
    "month": 3,
    "year": 4,
    "randomDate": 5
}

